<div style="position: sticky;overflow:auto;">
    <div class="top-header">
        <button class="freight-primary" style="margin-top: 5px;"  (click)="back()">Back<img src="../../assets/icons/return-icon.svg" style="height: 14px;margin-left: 5px;"></button>
        <div class="pt-status">
            <div>
                <div>STATUS</div>
                <div>
                    <span class="status" [ngClass]="{'rejected_status': invoiceResult?.StatusId === 112,'passed_status': invoiceResult?.StatusId === 108,'passed-awaiting-status' : invoiceResult?.StatusId === 103 , 'rejected-awaiting-status': invoiceResult?.StatusId === 104, 'inWeb_status': invoiceResult?.StatusId === 106, 'inprog_status': containsOpen(invoiceResult?.StatusId)  }">{{ filterStatus(invoiceResult) | uppercase }}</span>
                   
                </div>
            </div>
        </div>
        <div class="pt-status">
            <div>
                <div style="margin-top: 5px;" >DAYS IN CURRENT STATUS</div>
                <div style="color: #2b3834;margin-top: 5px;">{{ invoiceResult?.DaysInResolution | uppercase}}</div>
            </div>
        </div>
        <div class="pt-status">
            <div>
                <div style="margin-top: 5px;" >CURRENT ACTION OWNER</div>
                <div style="margin-top: 5px;">{{ allocation | uppercase }}</div>
            </div>
        </div>
        <button style="float:right;margin:0;margin-top: 5px;" class="freight-primary"  (click)="viewDocument()">View Attachments</button>
    </div>

    <kendo-splitter orientation="horizontal" style="height: 100vh;border:0" >
        <kendo-splitter-pane size="50%">
            <div class="details-container">
                
                <div class="row">
                    <div class="col-md-6">
                        <div class="client-profile">
                            <img src="../../assets/icons/client-icon-50x50.svg" alt="">
                            <div>
                                <div style="margin-bottom: -5px;font-weight: 800;color: #48484c;">Client Profile</div>
                                <div class="title" style="font-size: 25px;font-weight: bold;color: #48484c;font-family: 'Roboto';">{{ invoiceResult?.Client?.Name }}</div>
                                <div style="margin-left: -50px;font-weight: 800;color: #48484c;">{{invoiceResult?.Client?.Country}} {{invoiceResult?.Client?.City}}</div>
                                <div style="margin-left: -50px;font-weight: 800;color: #48484c;">{{(invoiceResult?.Client?.Address1)?invoiceResult?.Client?.Address1:invoiceResult?.Client?.Address2}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="client-profile">
                            <img src="../../assets/icons/carreer-icon-50x50.svg" alt="">
                            <div>
                                <div style="margin-bottom: -5px;font-weight: 800;color: #48484c;">Carrier Profile</div>
                                <div class="title" style="font-size: 25px;font-weight: bold;color: #48484c;font-family: 'Roboto';">{{ invoiceResult?.Carrier?.Name }}</div>
                                <div style="margin-left: -50px;font-weight: 800;color: #48484c;">{{invoiceResult?.Carrier?.Country}} {{invoiceResult?.Carrier?.City}}</div>
                                <div style="margin-left: -50px;font-weight: 800;color: #48484c;">{{(invoiceResult?.Carrier?.Address1)?invoiceResult?.Carrier?.Address1:invoiceResult?.Carrier?.Address2}}</div>
                            </div>
                        </div>
                    </div>
                </div> 
 
                <div nz-row class="infos">
                    <div class="btn-list">
                        <!-- <button nz-button [nzSize]="'small'" nzType="default" (click)="viewDocument()">View Attachments</button> -->
                        <!-- <button nz-button [nzSize]="'small'" *ngIf="invoiceResult?.StatusId === 106" nzType="default" (click)="attachDocument()">Attach Document</button> -->
                        <!-- <button nz-button [nzSize]="'small'" nzType="default" (click)="exportData()">Export Shipment Data</button> -->
                    </div>

                    <div nz-row class="infos" style="margin-top: 15px" *ngIf="invoiceResult?.ResolutionReasonCode">
                        <div class="title">Exception Information</div>
                        <div class="info-list-2" style="margin-top: 15px;font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;">   
                            <div class="info-wrapper" >
                                <div class="title-header" style="background: #ffc7ce;font-size: 12px;font-weight: 700;color: #3a3838;">
                                    Reason Code :
                                </div>
                                <div class="content" style="font-size: 11px;border: 1px solid #d8d8d8;border-top: none;border-left: none;">
                                    <div>{{invoiceResult?.ResolutionReasonCode}}</div>
                                </div>
                            </div>
                            <div class="info-wrapper">
                                <div class="title-header" style="background: #ffc7ce;font-size: 12px;font-weight: 700;color: #3a3838;">
                                    Reason Code  Description :
                                </div>
                                <div class="content" style="font-size: 11px;border: 1px solid #d8d8d8;border-top: none;border-left: none;">
                                    <div>{{invoiceResult?.ResolutionDescription}}</div>
                                </div>
                            </div>
                            <div class="info-wrapper">
                                <div class="title-header" style="background: #ffc7ce;font-size: 12px;font-weight: 700;color: #3a3838;">
                                    Auditors Remarks :
                                </div>
                                <div class="content" style="font-size: 11px;border-right: 1px solid #d8d8d8;">
                                    <div>{{invoiceResult?.ResolutionAuditorsRemarks}}</div>
                                </div>
                            </div>
                        </div>                     
                    </div>

                    <div nz-row class="infos" *ngIf="invoiceResult?.LatestComments">
                        <div class="title">Latest Comment</div>
                        <div class="info-list-2" >
                            <div class="info-wrapper">
                                <div class="title-header">
                                    {{invoiceResult?.LatestComments?.userCompany}}
                                </div>
                                <div class="content">
                                    <div>
                                        {{invoiceResult?.LatestComments?.userFirstName}}   {{invoiceResult?.LatestComments?.userinitial}} <span>{{invoiceResult?.LatestComments?.posteDate | date: 'dd/MMM/yyyy'}}</span>
                                    </div>
                                    <div [innerHTML]="invoiceResult?.LatestComments.userMessage"></div>
                                </div>
                            </div>
                            <div *ngIf="hasWebRes" >
                                <textarea rows="4" nz-input placeholder="Comment here..."></textarea>
                                <div class="btn-list">
                                    <button nz-button nzType="default">Send To Carrier</button>
                                    <button nz-button nzType="default">Send To CT Global</button>
                                    <button nz-button nzType="default">Approve Invoice</button>
                                    <button nz-button nzType="default">Reject Invoice</button>
                                </div>
                            </div>
                        </div>
                        <span class="gotoBottom" (click)="scroll(commentHistory)">View all Comments<i style="font-size: 15px;margin: 5px;color: #1973d4;cursor: pointer;" class="fa fa-arrow-down" aria-hidden="true"  ></i></span>
                    </div>

                   
                </div>

                    <div class="folder-like">
                        <h4 class="tab">INVOICE INFORMATION</h4>
                    </div>
                    <div style="padding: 10px;background: #ffffff; margin-top: -5px;">
                        <table class="table wl-table-m">
                                <thead class="wl-thead-b">
                                    <tr>
                                        <th class="ctgf-tbl-inv-tr-th"> <h6 class="ctgf-tbl-inv-tr-th-h6">INVOICE NUMBER</h6></th>
                                        <th class="ctgf-tbl-inv-tr-th"> <h6 class="ctgf-tbl-inv-tr-th-h6">INVOICE DATE</h6></th>
                                        <th class="ctgf-tbl-inv-tr-th"> <h6 class="ctgf-tbl-inv-tr-th-h6">DUE DATE</h6></th>
                                        <th class="ctgf-tbl-inv-tr-th"> <h6 class="ctgf-tbl-inv-tr-th-h6">CURRENCY</h6></th>
                                        <th class="ctgf-tbl-inv-tr-th"> <h6 class="ctgf-tbl-inv-tr-th-h6">INVOICE AMOUNT</h6></th>
                                        <th class="ctgf-tbl-inv-tr-th"> <h6 class="ctgf-tbl-inv-tr-th-h6">RATED AMOUNT</h6></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="ctgf-tbl-inv-tr-td-h5">{{invoiceResult?.InvoiceNo}}</td>
                                        <td class="ctgf-tbl-inv-tr-td-h5">{{invoiceResult?.InvoiceDate| date: 'dd/MMM/yyyy'}}</td>
                                        <td class="ctgf-tbl-inv-tr-td-h5">{{invoiceResult?.DueDate| date: 'dd/MMM/yyyy'}}</td>
                                        <td class="ctgf-tbl-inv-tr-td-h5">{{invoiceResult?.Currency}}</td>
                                        <td class="ctgf-tbl-inv-tr-td-h5">{{invoiceResult?.BilledAmount  | number : '1.2-2' }}</td>
                                        <td class="ctgf-tbl-inv-tr-td-h5"></td>
                                    </tr> 
                                </tbody>
                        </table>
                    </div>
                <div nz-row class="infos" nzGutter="12">
                    
                    <div nz-col nzSpan="12">

                        <div class="folder-like">
                            <h4 class="tab">INVOICE ID'S</h4>
                        </div>
                        <div style="padding: 10px;background: #ffffff; margin-top: -5px;">
                           <kendo-grid class="invoiceTable" #invoiceTable [data]="invoiceResult?.InvoiceIds" [height]="200" >
                                <kendo-grid-column field="Name" title="Field Name" width="50" [headerStyle]="{ 'background-color': '#0f3f6f', color: '#e8e3e3' }">
                                </kendo-grid-column>
                                <kendo-grid-column field="Value" title="Field Value" width="50" [headerStyle]="{ 'background-color': '#0f3f6f', color: '#e8e3e3' }">
                                </kendo-grid-column>
                            </kendo-grid>
                          </div>
<!-- 
                       <div class="content">
                            <table class="table wl-table-m">
                                    <thead class="wl-thead-b">
                                        <tr>
                                            <th class="ctgf-tbl-inv-tr-th"> <h6 class="ctgf-tbl-inv-tr-th-h6">FIELD NAME</h6></th>
                                            <th class="ctgf-tbl-inv-tr-th"> <h6 class="ctgf-tbl-inv-tr-th-h6">FIELD VALUE</h6></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let data of invoiceResult?.InvoiceIds">
                                            <td class="ctgf-tbl-inv-tr-td-h5">{{data?.Name}}</td>
                                            <td class="ctgf-tbl-inv-tr-td-h5">{{data?.Value}}</td>
                                        </tr> 
                                    </tbody>
                            </table>
                       </div> -->
                    </div>

                    <div nz-col nzSpan="12">

                        <div class="folder-like">
                            <h4 class="tab">INVOICE HISTORY</h4>
                        </div>
                        <div style="padding: 10px;background: #ffffff; margin-top: -5px;">
                            <kendo-grid
                            class="invoiceTable"
                            #invoiceTable                 
                            [data]="invoiceResult?.InvoiceHistories" 
                            [height]="200" 
                            [resizable]="true">
                                <kendo-grid-column field="HistoryDate" title="Date" width="25" [headerStyle]="{ 'background-color': '#0f3f6f', color: '#e8e3e3' }">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        {{dataItem.HistoryDate | date: 'dd/MMM/yyyy'}}
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="Description" title="Description" width="50" [headerStyle]="{ 'background-color': '#0f3f6f', color: '#e8e3e3' }">
                                </kendo-grid-column>
                            </kendo-grid>
                        </div>

                        <!-- <div class="content">

                            <table class="table wl-table-m">
                                    <thead class="wl-thead-b">
                                        <tr>
                                            <th class="ctgf-tbl-inv-tr-th"> <h6 class="ctgf-tbl-inv-tr-th-h6">FIELD NAME</h6></th>
                                            <th class="ctgf-tbl-inv-tr-th"> <h6 class="ctgf-tbl-inv-tr-th-h6">FIELD VALUE</h6></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let data of invoiceResult?.InvoiceHistories">
                                            <td class="ctgf-tbl-inv-tr-td-h5">{{data?.HistoryDate |  date: 'dd/MMM/yyyy' }}</td>
                                            <td class="ctgf-tbl-inv-tr-td-h5">{{data?.Description }}</td>
                                        </tr> 
                                    </tbody>
                            </table>
                        </div> -->
                    </div>
                    
                </div>                

                <div nz-row class="infos">
                    <!-- <div class="title">Shipments
                        <button nz-button [nzSize]="'small'" style="float: right;padding-bottom: 3px;" nzType="default" (click)="exportData()">Export Shipment Data</button>
                    </div> -->
                    <div class="folder-like">
                        <h4 class="tab">SHIPMENTS</h4>
                    </div>

                    <div style="padding: 10px;background: #ffffff; margin-top: -10px;">
                        <div >
                            <kendo-grid           
                            #invoiceTable
                            class="invoiceTable"
                            [data]="shipmentGridView" 
                            [pageSize]="pageSize"
                            [columnMenu]="true"
                            [skip]="skip"
                            [pageable]="true" 
                            [resizable]="true"
                            (pageChange)="pageChange($event)"
                            >
          
                                  <kendo-grid-column field="Id" title="Shipment #" width="30" [columnMenu]="true" [headerStyle]="{ 'background-color': '#0f3f6f', color: '#e8e3e3' }">
                                      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                                          {{rowIndex + 1}}
                                      </ng-template>
                                  </kendo-grid-column>
          
                                  <kendo-grid-column field="Id" title="Shipment Id" width="30" [columnMenu]="false" [headerStyle]="{ 'background-color': '#0f3f6f', color: '#e8e3e3' }">
                                  </kendo-grid-column>
          
                                  <kendo-grid-column field="OriginCountryCode" title="Origin" width="30" [columnMenu]="false" [headerStyle]="{ 'background-color': '#0f3f6f', color: '#e8e3e3' }">
                                  </kendo-grid-column>
                                  
                                  <kendo-grid-column field="DestinationCountryCode" title="Destination" width="40" [columnMenu]="false" [headerStyle]="{ 'background-color': '#0f3f6f', color: '#e8e3e3' }">
                                  </kendo-grid-column>
                                  
                                  <kendo-grid-column field="ShipmentMode" title="Mode" width="50" [columnMenu]="false" [headerStyle]="{ 'background-color': '#0f3f6f', color: '#e8e3e3' }">
                                  </kendo-grid-column>
          
                                  <kendo-grid-column field="ShipmentCurrencyCode" title="Currency" width="40" [columnMenu]="false" [headerStyle]="{ 'background-color': '#0f3f6f', color: '#e8e3e3' }">
                                  </kendo-grid-column>
          
                                  <kendo-grid-column  field="BilledAmount" title="Amount" width="40" [columnMenu]="false" [headerStyle]="{ 'background-color': '#0f3f6f', color: '#e8e3e3' }">
                                        <ng-template kendoGridCellTemplate let-dataItem>
                                            <span>{{dataItem.BilledAmount |  number : '1.2-2' }} </span>
                                        </ng-template>
                                  </kendo-grid-column>
          
                                  <kendo-grid-column title="Details" width="20" [columnMenu]="false" [headerStyle]="{ 'background-color': '#0f3f6f', color: '#e8e3e3' }">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                          <i nz-icon class="details-icon" (click)="showShipmentDetails(dataItem)" nzType="form" nzTheme="outline"></i>
                                      </ng-template>
                                  </kendo-grid-column>
                              </kendo-grid>
                          </div>
                    </div>
                </div>

                <div nz-row class="infos" nzGutter="16">

                    <div nz-col nzSpan="12"> 
                        <div class="folder-like">
                            <h4 class="tab">LATEST COMMENTS</h4>
                        </div>
                        
    
                        <div class="info-list-2" *ngIf="invoiceResult?.LatestComments">
                            <div class="info-wrapper">
                                <div class="title-header">
                                    {{invoiceResult?.LatestComments?.userCompany}}
                                </div>
                                <div class="content">
                                    <div>
                                        {{invoiceResult?.LatestComments?.userFirstName}}   {{invoiceResult?.LatestComments?.userinitial}} <span>{{invoiceResult?.LatestComments?.posteDate | date: 'dd/MMM/yyyy'}}</span>
                                    </div>
                                    <div [innerHTML]="invoiceResult?.LatestComments.userMessage"></div>
                                </div>
                            </div>
                        </div>

                        <div class="content">
                            <nz-empty *ngIf="!(invoiceResult?.LatestComments)"></nz-empty>
                            <div *ngIf="hasWebRes" >
                                <textarea rows="4" nz-input placeholder="Comment here..."></textarea>
                                <div class="btn-list">
                                    <button nz-button nzType="default">Send To Carrier</button>
                                    <button nz-button nzType="default">Send To CT Global</button>
                                    <button nz-button nzType="default">Approve Invoice</button>
                                    <button nz-button nzType="default">Reject Invoice</button>
                                </div>
                            </div>
                        </div>
                        
                    </div>

                    <div nz-col nzSpan="12">
                        <div class="folder-like">
                            <h4 class="tab">COMMENT HISTORY</h4>
                        </div>
    
                       <div class="content">
                            <div class="info-list-2" *ngFor="let comment of invoiceResult?.CommentHistory">
                                <div class="info-wrapper">
                                    <div class="title-header">
                                        {{comment?.userCompany}}
                                    </div>
                                    <div class="content">
                                        <div>
                                            {{comment?.userFirstName}}   {{comment?.userinitial}} <span>{{comment?.posteDate | date: 'dd MMM yyyy'}}</span>
                                        </div>
                                        <div [innerHTML]="comment.userMessage"></div>
                                    </div>
                                </div>
                            </div>
                            <nz-empty *ngIf="!(invoiceResult?.CommentHistory) || invoiceResult?.CommentHistory.length == 0"></nz-empty>
                       </div>
                    </div>

                  
                </div>

                <!-- <div nz-row class="infos" #commentHistory>

                    <div class="folder-like">
                        <h4 class="tab">COMMENT HISTORY</h4>
                    </div>

                    <div class="info-list-2" *ngFor="let comment of invoiceResult?.CommentHistory">
                        <div class="info-wrapper">
                            <div class="title-header">
                                {{comment?.userCompany}}
                            </div>
                            <div class="content">
                                <div>
                                    {{comment?.userFirstName}}   {{comment?.userinitial}} <span>{{comment?.posteDate | date: 'dd MMM yyyy'}}</span>
                                </div>
                                <div [innerHTML]="comment.userMessage"></div>
                            </div>
                        </div>
                    </div>
                    <nz-empty *ngIf="!(invoiceResult?.CommentHistory) || invoiceResult?.CommentHistory.length == 0"></nz-empty>
                </div>   -->



            </div>
        </kendo-splitter-pane>

        <kendo-splitter-pane [collapsible]="true" (collapsedChange)="detectCollapse($event)">
            <div class="no-img">
                <img #noimg src="/assets/images/alert/No-image-available.png">
                <iframe #invoicePDF id="invoicePDFframe" name="invoicePDFframe"  [src]="pdfSrc" frameborder="0" allowfullscreen > </iframe>
            </div>
        </kendo-splitter-pane>

    </kendo-splitter>
</div>

<div class="shipdata">
    <kendo-window  title="Shipment Details"  *ngIf="isVisible" (close)="handleCancel()" >
        <div class="row">
            <div class="col-md-6"> 
                    <div style="margin-left: 10px;  width: 500px;">
                        <label>Shipment IDs</label>
                        <kendo-grid #asmple 
                        [data]="gridViewInvoiceSIDs" 
                        [navigable]="true" 
                        [height]="130" 
                        [sort]="sortGridInvoiceSIDs" 
                        [sortable]="true"  
                        (sortChange)="sortChangeInvoiceSIDs($event)">
                            <kendo-grid-column field="Name" title="SID Type" width="50">
                            </kendo-grid-column>
                            <kendo-grid-column field="Value" title="Value" width="50">
                            </kendo-grid-column>
                        </kendo-grid>
                    </div>   
                    
                    <div class="row" style="margin-left: 10px;
                    margin-top: 30px;
                    width: 500px;
                    border: 1px solid #b6b7b677;
                    border-radius: 3px;
                    padding: 4px;
                    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;">
                                    <div class="col-md-4">
                                            <label style="font-size: 12px;">Origin</label>
                                            <br>
                                            <div style="font-size: 11px;font-weight: 100">{{shipmentInformation?.ConsigneeName }}</div>
                                            <div style="font-size: 11px;font-weight: 100">{{shipmentInformation?.OriginCity }}</div>
                                            <div style="font-size: 11px;font-weight: 100">{{shipmentInformation?.OriginPostCode }}</div>
                                            <img class="flag-big"  [src]="getCountryFlag(shipmentInformation?.OriginCountryCode)" alt="" style="width: 30px;"/>
                                            <div>
                                                <span style="font-size: 11px;font-weight: 100"> {{ shipmentInformation?.OriginCountryCode }}</span>
                                            </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div >
                                            <label style="font-size: 12px;">Destination</label>
                                            <br>
                                            <div style="font-size: 11px;font-weight: 100">{{shipmentInformation?.ShipperName }}</div>
                                            <div style="font-size: 11px;font-weight: 100">{{shipmentInformation?.DestinationCity }}</div>
                                            <div style="font-size: 11px;font-weight: 100">{{shipmentInformation?.DestinationPostCode }}</div>
                                            <img class="flag-big"  [src]="getCountryFlag(shipmentInformation?.DestinationCountryCode)" alt="" style="width: 30px;"/>
                                            <div>
                                                <span style="font-size: 11px;font-weight: 100"> {{ shipmentInformation?.DestinationCountryCode }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div >
                                            <label style="font-size: 12px;">Shipment Mode 
                                                <div>
                                                    <span style="font-size: 11px;font-weight: 100">{{shipmentInformation?.ShipmentMode}}</span>
                                                </div>
                                            </label>
                                        </div>
                                    </div>

                    <!-- <div class="row" style="margin-left: 10px; margin-top: 30px;  width: 500px;">
                      <kendo-grid #asmple [data]="OriginDestination" [navigable]="true" [height]="130" >
                          <kendo-grid-column field="col1" title="Origin">
                              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex"> 
                                  <div *ngIf = "rowIndex != 2" >
                                      {{dataItem.col1}}
                                  </div>
                                  <div *ngIf = "rowIndex == 2" >
                                      <span>
                                          {{dataItem.col1}}
                                          <img class="flag-big"  [src]="getCountryFlag(shipmentInformation?.OriginCountryCode)" alt="" style="width: 30px;"/>
                                      </span>
                                  </div>
                             </ng-template>
                          </kendo-grid-column>

                          <kendo-grid-column field="col2" title="Destination">
                              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex"> 
                                  <div *ngIf = "rowIndex != 2" >
                                      {{dataItem.col2}}
                                  </div>
                                  <div *ngIf = "rowIndex == 2" >
                                      <span>
                                          {{dataItem.col2}}
                                          <img class="flag-big"  [src]="getCountryFlag(shipmentInformation?.DestinationCountryCode)" alt="" style="width: 30px;"/>
                                      </span>
                                  </div>
                             </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-column field="col3" title="Shipment Mode">
                          </kendo-grid-column>
                      </kendo-grid> -->
                </div>
            </div>
            <div class="col-md-6">
                <div style=" width: 500px;">
                    <label>Client Fields</label>
                    <kendo-grid #asmple 
                    [data]="gridViewInvoiceClientFields" 
                    [navigable]="true" 
                    [height]="130" 
                    [sort]="sortGridClientFields" 
                    [sortable]="true"  
                    (sortChange)="sortChangeInvoiceClientFields($event)">
                        <kendo-grid-column field="FieldName" title="Field Name" width="50">
                        </kendo-grid-column>
                        <kendo-grid-column field="Value" title="Value" width="50">
                        </kendo-grid-column>
                    </kendo-grid>
                </div>
                <div class="row">
                    <div class="row" style="margin-left: 10px;
                    margin-top: 30px;
                    width: 500px;
                    border: 1px solid #b6b7b677;
                    border-radius: 3px;
                    padding: 4px;
                    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;">
                            <div class="col-md-3">
                                <label style="font-size: 12px;">Service Type 
                                    <div>
                                        <span style="font-size: 11px;font-weight: 100">{{shipmentInformation?.ServiceType}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-md-3">
                                <label style="font-size: 12px;">Terms 
                                    <div>
                                        <span style="font-size: 11px;font-weight: 100">{{shipmentInformation?.FreightTerms}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-md-3">
                                <label style="font-size: 12px;">Shipment Date 
                                    <div>
                                        <span style="font-size: 11px;font-weight: 100">{{shipmentInformation?.ShipmentDate | date: 'dd/MM/yyyy'}}</span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-md-3">
                                <label style="font-size: 12px;">Delivery Date 
                                    <div>
                                        <span style="font-size: 11px;font-weight: 100">{{shipmentInformation?.DeliveryDate | date: 'dd/MM/yyyy'}}</span>
                                    </div>
                                </label>
                            </div>
                  <!-- <div  style="margin-left: 10px; margin-top: 30px;  width: 500px;">
                      <kendo-grid #asmple [data]="services" [navigable]="true" [height]="130" >
                          <kendo-grid-column field="col1" title="Service Type">
                          </kendo-grid-column>

                          <kendo-grid-column field="col2" title="Terms">
                          </kendo-grid-column>

                          <kendo-grid-column field="col3" title="Shipment Date">
                              <ng-template  kendoGridCellTemplate let-dataItem>
                                  {{dataItem.col3 | date: 'dd/MMM/yyyy'}}
                              </ng-template>
                          </kendo-grid-column>

                          <kendo-grid-column field="col4" title="Delivery Date">
                              <ng-template  kendoGridCellTemplate let-dataItem>
                                  {{dataItem.col3 | date: 'dd/MMM/yyyy'}}
                              </ng-template>
                          </kendo-grid-column>
                      </kendo-grid>
                    </div> -->
                </div>
                </div> 
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-md-6" >
                <div style="margin-left: 10px;  width: 500px;">
                    <label>Units of Measure</label>
                    <kendo-grid #asmple 
                    [data]="gridViewInvoiceUoms"  
                    [navigable]="true" 
                    [height]="130" 
                    [sort]="sortGridInvoiceUoms" 
                    [sortable]="true"  
                    (sortChange)="sortChangeInvoiceInvoiceUoms($event)">
                        <kendo-grid-column field="UOM.Code" title="UOM Type" width="50">
                        </kendo-grid-column>
                        <kendo-grid-column format={0:n0}  field="Amount" title="Invoice Value" width="50">
                        </kendo-grid-column>
                    </kendo-grid>
                </div>
            </div>
            <div class="col-md-6">
                <div style=" width: 500px;">
                    <label>Charges</label>
                    <kendo-grid #asmple 
                    [data]="gridViewInvoiceAccessorials" 
                    [navigable]="true" 
                    [height]="130" 
                    [sort]="sortGridInvoiceAccessorials" 
                    [sortable]="true"  
                    (sortChange)="sortChangeInvoiceInvoiceAccessorials($event)">
                        <kendo-grid-column field="Code" title="Code" width="50">
                            <ng-template
                                 kendoGridFooterTemplate
                                    let-column="column">Total
                                </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column  format="{0:n2}" field="Amount" title="Amount" width="50">
                   
                        </kendo-grid-column>
                    </kendo-grid>
                </div>
            </div>
        </div>
      </kendo-window>      
  </div>

<div class="openwindow"> 
    <kendo-window  title="Download Files"  *ngIf="showDownload"     (close)="closeDownload()"  >
        <div class="modal-body download-modal-body">
            <div  *ngFor="let  invAttach of invoiceAttachment" >
            <a>
                <span (click)="downloadAttachment(invAttach)" class="download-modal-att"> {{invAttach.RawFileName}} </span> 
            </a>
          </div>
        </div>
        <div class="modal-footer att-modal-footer">
          <button type="button" class="btn btn-info btn-secondary btn-modal-footer-x" (click)="closeDownload()">Close</button>
        </div>
    </kendo-window>
</div>
